import React from 'react'

import { Text } from '@wartek-id/text-v1'
import { Checkbox } from '@wartek-id/checkbox-v1'
import { Icon } from '@wartek-id/icon-v2'

import type { IInputIndicator } from 'app/PemetaanKompetensiPage/pages/RencanaPengembanganDiri/Main'
import type { TProficiency } from 'types/competency-profile'
import type { FC, HTMLProps } from 'react'

interface CompetencyIndicatorCheckboxProps extends HTMLProps<HTMLDivElement> {
  indicator_key: string
  name: string
  description: string
  proficiency?: TProficiency
  handleAddReason: Function
  inputIndicatorData?: IInputIndicator
  handleCheckboxIndicator: (IInputIndicator) => void
}

const CompetencyIndicatorCheckbox: FC<CompetencyIndicatorCheckboxProps> = ({
  indicator_key,
  name,
  description,
  handleAddReason,
  handleCheckboxIndicator,
  inputIndicatorData,
}) => {
  return (
    <Checkbox
      className="py-4 border-b border-gray-10 last:border-none last:mb-3 rpd-checkbox"
      checked={!!inputIndicatorData}
      controlled
      onChange={() =>
        handleCheckboxIndicator({
          indicator_key,
          reason: '',
          needs: '',
        })
      }
    >
      <Text variant="action">{name}</Text>
      <div>
        <Text className="mb-2 mt-0.5">{description}</Text>
        {!!inputIndicatorData && (
          <div
            className="bg-gray-5 p-3 rounded-lg space-y-1 mt-3 cursor-pointer break-all"
            onClick={(event) => {
              event.preventDefault()
              handleAddReason()
            }}
          >
            {!inputIndicatorData?.reason && (
              <>
                <Text variant="body-sm-bold">Alasan dan Kebutuhan</Text>
                <Text variant="helper">
                  Anda wajib mengisi alasan Anda dalam memilih indikator ini.
                </Text>
              </>
            )}
            {inputIndicatorData?.reason && (
              <>
                <div className="flex flex-row justify-between">
                  <Text variant="body-sm-bold">Alasan</Text>
                  <div className="flex flex-row items-center">
                    <Icon fontSize="sm">edit</Icon>
                    <Text className="underline">ubah</Text>
                  </div>
                </div>
                <Text variant="helper">{inputIndicatorData.reason}</Text>
              </>
            )}
            {inputIndicatorData?.needs && (
              <>
                <Text variant="body-sm-bold">Kebutuhan</Text>
                <Text variant="helper">{inputIndicatorData.needs}</Text>
              </>
            )}
            {!inputIndicatorData?.reason && (
              <Text color="primary" className="underline">
                isi alasan dan kebutuhan Anda
              </Text>
            )}
          </div>
        )}
      </div>
    </Checkbox>
  )
}

export default CompetencyIndicatorCheckbox
